export default function CAEditCustomerLogoDirective() {
  return {
    template: require('./edit-customer-logo.directive.html'),
    scope: {
      customer: '=',
    },
    controller: 'CAEditCustomerLogoDirectiveController',
    controllerAs: 'editCustomerLogoVM',
    bindToController: true,
    replace: true,
  };
}
